export default {
    "enemies": [
        {
            "name": "koopa",
            "x": 200,
            "y": 300,
            "x1Limit": 200,
            "x2Limit": 800,
            "trigger": 0
        },
        {
            "name": "koopa",
            "x": 800,
            "y": 300,
            "x1Limit": 200,
            "x2Limit": 800,
            "trigger": 0
        },
        {
            "name": "koopa",
            "x": 1200,
            "y": 200,
            "x1Limit": 1200,
            "x2Limit": 1900,
            "trigger": 600
        },
        {
            "name": "koopa",
            "x": 3600,
            "y": 0,
            "x1Limit": 3300,
            "x2Limit": 3600,
            "trigger": 3100
        },
        {
            "name": "koopa",
            "x": 5100,
            "y": 0,
            "x1Limit": 4700,
            "x2Limit": 5120,
            "trigger": 4500
        },
        {
            "name": "dragon",
            "x": 4580,
            "y": 0,
            "x1Limit": 4400,
            "x2Limit": 4580,
            "trigger": 3800
        },
        {
            "name": "dragon",
            "x": 400,
            "y": 300,
            "x1Limit": 200,
            "x2Limit": 800,
            "trigger": 0
        },
        {
            "name": "dragon",
            "x": 1900,
            "y": 200,
            "x1Limit": 1200,
            "x2Limit": 1900,
            "trigger": 600
        },
        {
            "name": "dragon",
            "x": 1500,
            "y": 200,
            "x1Limit": 1200,
            "x2Limit": 1900,
            "trigger": 600
        },
        {
            "name": "dragon",
            "x": 2900,
            "y": 200,
            "x1Limit": 2700,
            "x2Limit": 3100,
            "trigger": 2000
        },
        {
            "name": "dragon",
            "x": 4000,
            "y": 200,
            "x1Limit": 3950,
            "x2Limit": 4050,
            "trigger": 3500
        },
        {
            "name": "dragon",
            "x": 4700,
            "y": 0,
            "x1Limit": 4700,
            "x2Limit": 5120,
            "trigger": 4000
        },
        {
            "name": "dragon",
            "x": 5500,
            "y": 0,
            "x1Limit": 5350,
            "x2Limit": 5600,
            "trigger": 5000
        },
        {
            "name": "bullet",
            "x": 1300,
            "y": 90,
            "trigger": 700
        },
        {
            "name": "bullet",
            "x": 3700,
            "y": 10,
            "trigger": 3300
        },
        {
            "name": "bullet",
            "x": 4400,
            "y": 125,
            "trigger": 4000
        },
        {
            "name": "bullet",
            "x": 5100,
            "y": 10,
            "trigger": 4700
        },
        {
            "name": "bullet",
            "x": 4800,
            "y": 10,
            "trigger": 4400
        },
    ]
}